module.exports = __webpack_public_path__ + "img/Millionaire-1.5585e964.gif";